import { FileInfoModel } from './file-info-model.model';

export enum FileUploadEditOnlineModalComponentMode {
  View = 1,
  Edit = 2
}

export interface FileUploadEditOnlineModalComponentData {
  mode: FileUploadEditOnlineModalComponentMode;
  docheckoutcheckin: boolean;
  fromGrid?: {
    collectionId: number;
    instanceId: number;
    versionId: number;
  } | undefined;
  mediaId: number;
  filename: string;
  modificationreason: string;
  closeModalMethod: () => void;
  finishMethod: (data: {
    modificationReasonFromOnlineEdit: string,
    openedOneDriveWindow: any | undefined,
    mediaId: number | undefined,
    oneDriveKey: string,
    lastModified: string,
    fileInfo: FileInfoModel | undefined
  }, onError?: (error: any | undefined) => void) => void;
}